import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["width", "height", "aspectRatio"]

  connect() {
  }

  calculate() {
    const width = parseFloat(this.widthTarget.value) || 0
    const height = parseFloat(this.heightTarget.value) || 0

    if (width && height) {
      // Calculate and validate aspect ratio
      const aspectRatio = this.calculateAspectRatio(width, height)
      this.aspectRatioTarget.value = aspectRatio
    }
  }

  calculateAspectRatio(width, height) {
    const gcd = this.calculateGCD(width, height)
    const simplifiedWidth = width / gcd
    const simplifiedHeight = height / gcd

    const commonRatios = {
      '16:9': [16, 9],
      '4:3': [4, 3],
      '21:9': [21, 9],
      '32:9': [32, 9],
      '1:1': [1, 1],
      '3:2': [3, 2]
    }

    // Check if it matches a common ratio
    for (const [ratio, [w, h]] of Object.entries(commonRatios)) {
      if (Math.abs((width / height) - (w / h)) < 0.01) {
        return ratio
      }
    }

    // If no common ratio found, return simplified custom ratio
    return `${Math.round(simplifiedWidth)}:${Math.round(simplifiedHeight)}`
  }

  // Function to calculate Greatest Common Divisor
  calculateGCD(a, b) {
    while (b) {
      let temp = b
      b = a % b
      a = temp
    }
    return a
  }

  validateAspectRatio() {
    const aspectRatio = this.aspectRatioTarget.value
    const isValid = /^\d+:\d+$/.test(aspectRatio) // Basic format check
    if (!isValid) {
      this.aspectRatioTarget.classList.add('border-red-500')
    } else {
      this.aspectRatioTarget.classList.remove('border-red-500')
    }
  }
}